import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import { Scrollbars } from 'react-custom-scrollbars'
import { renderThumb, renderTrackVertical } from '../../resources/theme/q4.custom-scrollbar'
import { Spinner } from '../../components'
import { getClassName } from '../../utils'

import './modal.component.scss'

const styles = {}

/**
 * Modal Component
 */
class Modal extends Component {

  /**
   * Render Action Button
   * @param button
   * @param index
   */
  renderActionButton = (button, index) => {
    const { ui, icon, label, hidden, invisible, loading, disabled, ref, onClick } = button

    const buttonClass = getClassName('button button--tall', [
      { condition: ui, trueClassName: `button--${ui}` },
      { condition: (icon && !(label && label.length)), trueClassName: 'button--square' },
      { condition: invisible, trueClassName: 'button--invisible' },
      { condition: hidden, trueClassName: 'button--hidden' },
      { condition: loading, trueClassName: 'button--loading' },
      { condition: disabled, trueClassName: 'button--disabled' }
    ])

    return (
      <button key={`modal-button--${index}`} ref={ref} className={buttonClass} onClick={onClick}>
        {icon && <i className={`button_icon ${icon}`} />}
        {label}
      </button>
    )
  }

  /**
   * Render Modal Component
   * @return {XML}
   */
  render () {
    const {
      className, visible, loading, scrollable,
      badge, title, subtitle, closeIcon, buttons, fullscreen, children, onClose,
      contentPadding, contentHeight
    } = this.props

    const styles = {
      containerStyle: {
        width: fullscreen ? '100%' : 600,
        height: fullscreen ? '100%' : null
      },
      contentStyle: {
        minHeight: contentHeight ? contentHeight : 90
      },
      componentStyle: {
        padding: contentPadding ? contentPadding : fullscreen ? '40px 32px' : '0 24px 24px'
      },
      scrollbarStyles: {
        height: contentHeight ? contentHeight : 90
      }
    }

    const modalClass = getClassName('modal', [
      { condition: loading, trueClassName: 'modal--loading' },
      { condition: fullscreen, trueClassName: 'modal--fullscreen' },
      { condition: scrollable, trueClassName: 'modal--scrollable' }
    ])

    return (
      <Dialog
        className={`modal-root ${className || ''}`}
        classes={{ paper: modalClass }}
        open={!!visible}
        onClose={onClose}>
        <div className='modal_inner' style={styles.containerStyle}>
          <div className='modal_header'>
            {title && (<>
              {badge && (
                <div className='modal_badge'>
                  <i className={badge} />
                </div>
              )}
              <div className='modal_header-detail'>
                <h2 className='modal_title'>{title}</h2>
                {!!subtitle && (<h3 className='modal_subtitle'>{subtitle}</h3>)}
              </div>
            </>)}
            {closeIcon && (
              <div className='modal_exit' onClick={onClose}>
                <i className='q4i-close-4pt' />
              </div>
            )}
          </div>
          <div
            className={`modal_content ${(!buttons || !buttons.length) ? 'modal_content--footerless' : ''}`}
            style={styles.contentStyle}>
            {scrollable ? (
              <Scrollbars
                className='react-scrollbar'
                hideTracksWhenNotNeeded
                renderThumbVertical={renderThumb}
                renderTrackVertical={renderTrackVertical}
                style={styles.scrollbarStyles}>
                <div className='modal_component' style={styles.componentStyle}>{children}</div>
              </Scrollbars>
            ) : <div className='modal_component' style={styles.componentStyle}>{children}</div>}
            {loading ? (
              <Spinner
                mask={true}
                maskOpacity={0.5}
                maskColor='#FFF' />
            ) : null}
          </div>
          {(buttons && buttons.length) && (
            <footer className='modal_footer'>
              <div className='modal_actions modal_actions--left'>
                {buttons.filter((button) => button.align === 'left').map(this.renderActionButton)}
              </div>
              <div className='modal_actions modal_actions--right'>
                {buttons.filter((button) => button.align !== 'left').map(this.renderActionButton)}
              </div>
            </footer>
          )}
        </div>
      </Dialog>
    )
  }
}

Modal.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  visible: PropTypes.bool.isRequired,
  loading: PropTypes.bool,
  scrollable: PropTypes.bool,
  badge: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  buttons: PropTypes.array,
  closeIcon: PropTypes.bool,
  fullscreen: PropTypes.bool,
  onClose: PropTypes.func,
  contentPadding: PropTypes.string,
  contentHeight: PropTypes.number
}

Modal.defaultProps = {
  closeIcon: true
}

export default withStyles(styles)(Modal)